export enum TipoCampoEmEdicaoEnum {
    PROGRAMA = 'programa',
    CONTROLE = 'controle',
    VARIAVEL_AQUECIMENTO = 'variavel_aquecimento',
}
